import { lazy } from 'react';
import type { RouteObject } from 'react-router';

const IncidentDetailPage = lazy(() => import('./detail-page').then((m) => ({ default: m.IncidentDetailPage })));
const IncidentFormPage = lazy(() => import('./form-page').then((m) => ({ default: m.IncidentFormPage })));
const IncidentListPage = lazy(() => import('./list-page').then((m) => ({ default: m.IncidentListPage })));

export const incidentRoutes: RouteObject[] = [
  {
    path: 'incidents',
    handle: { crumb: 'Ticket Management' },
    children: [
      { index: true, element: <IncidentListPage /> },
      { path: 'new', element: <IncidentFormPage />, handle: { crumb: 'New incident' } },
      { path: ':id', element: <IncidentDetailPage />, handle: { crumb: (p: Record<string, string | undefined>) => p.id ?? 'Incident' } },
    ],
  },
];
